var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollapse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.333,
    cy: 14,
    r: 13.333,
    stroke: "#141140"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8638 15.147C12.8638 14.9399 12.6959 14.772 12.4888 14.772L9.11376 14.772C8.90665 14.772 8.73876 14.9399 8.73876 15.147C8.73876 15.3541 8.90665 15.522 9.11376 15.522H12.1138V18.522C12.1138 18.7291 12.2817 18.897 12.4888 18.897C12.6959 18.897 12.8638 18.7291 12.8638 18.522L12.8638 15.147ZM8.26517 19.9009L12.7539 15.4121L12.2236 14.8818L7.73483 19.3706L8.26517 19.9009Z",
    fill: "#141140"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1069 12.1558C15.1069 12.3629 15.2748 12.5308 15.4819 12.5308L18.8569 12.5308C19.064 12.5308 19.2319 12.3629 19.2319 12.1558C19.2319 11.9486 19.064 11.7808 18.8569 11.7808L15.8569 11.7808L15.8569 8.78075C15.8569 8.57365 15.689 8.40575 15.4819 8.40575C15.2748 8.40575 15.1069 8.57365 15.1069 8.78075L15.1069 12.1558ZM19.7055 7.40183L15.2168 11.8906L15.7471 12.4209L20.2359 7.93216L19.7055 7.40183Z",
    fill: "#141140"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.316dca239197f980a009aea4fa6af69f.svg";
export { ForwardRef as ReactComponent };